import retroComicsImgUrl from '/imgs/portrait_style_repainting/retro_comics.jpg';
import fairyTaleImgUrl from '/imgs/portrait_style_repainting/3D_fairy_tales.jpg';
import cartoonsImgUrl from '/imgs/portrait_style_repainting/cartoon.jpg';
import fresherImgUrl from '/imgs/portrait_style_repainting/fresher.jpg';
import futureStyleImgUrl from '/imgs/portrait_style_repainting/future_style.jpg';
import chineseTraditionalPaintingImgUrl from '/imgs/portrait_style_repainting/chinese_traditional_painting.jpg';
import generalsFightImgUrl from '/imgs/portrait_style_repainting/generals_fight.jpg';
import colorfulCartoonImgUrl from '/imgs/portrait_style_repainting/colorful_cartoon.jpg';
import refinedStateStyleImgUrl from '/imgs/portrait_style_repainting/refined_state_style.jpg';
import newYearStyleImgUrl from '/imgs/portrait_style_repainting/new_year_style.jpg';


import largeRetroComicsImgUrl from '/imgs/portrait_style_repainting/retro_comics_large.jpg';
import largeFairyTaleImgUrl from '/imgs/portrait_style_repainting/3D_fairy_tales_large.jpg';
import largeCartoonsImgUrl from '/imgs/portrait_style_repainting/cartoon_large.jpg';
import largeFresherImgUrl from '/imgs/portrait_style_repainting/fresher_large.jpg';
import largeFutureStyleImgUrl from '/imgs/portrait_style_repainting/future_style_large.jpg';
import largeChineseTraditionalPaintingImgUrl from '/imgs/portrait_style_repainting/chinese_traditional_painting_large.jpg';
import largeGeneralsFightImgUrl from '/imgs/portrait_style_repainting/generals_fight_large.jpg';
import largeColorfulCartoonImgUrl from '/imgs/portrait_style_repainting/colorful_cartoon_large.jpg';
import largeRefinedStateStyleImgUrl from '/imgs/portrait_style_repainting/refined_state_style_large.jpg';
import largeNewYearStyleImgUrl from '/imgs/portrait_style_repainting/new_year_style_large.jpg';

export enum ImgStyle {
    RetroComics = 0,
    '3DFairyTales' = 1,
    Cartoons = 2,
    Fresher = 3,
    FutureStyle = 4,
    ChineseTraditionalPainting = 5,
    GeneralsFight = 6,
    ColorfulCartoon = 7,
    RefinedStateStyle = 8,
    NewYearStyle = 9
}

export const imgStyleMap = {
    [ImgStyle.RetroComics]: '复古漫画',
    [ImgStyle["3DFairyTales"]]: '3D童话',
    [ImgStyle.Cartoons]: '二次元',
    [ImgStyle.Fresher]: '小清新',
    [ImgStyle.FutureStyle]: '未来科技',
    [ImgStyle.ChineseTraditionalPainting]: '国画古风',
    [ImgStyle.GeneralsFight]: '将军百战',
    [ImgStyle.ColorfulCartoon]: '炫彩卡通',
    [ImgStyle.RefinedStateStyle]: '清雅古风',
    [ImgStyle.NewYearStyle]: '喜迎新年',

}

export const imgStyleReverseMap = Object.keys(imgStyleMap).reduce((pre, cur) => {
    pre[imgStyleMap[cur]] = cur;
    return pre;
}, {});

export const enum SizeType {
    '1:1' = '1024*1024',
    '16:9' = '1280*720',
    '9:16' = '720*1280'
}

export const imgStyleOptions = [
    {
        url: chineseTraditionalPaintingImgUrl,
        largeImgUrl: largeChineseTraditionalPaintingImgUrl,
        styleName: imgStyleMap[ImgStyle.ChineseTraditionalPainting],
        style: ImgStyle.ChineseTraditionalPainting,
        selected: true
    },
    {
        url: generalsFightImgUrl,
        largeImgUrl: largeGeneralsFightImgUrl,
        styleName: imgStyleMap[ImgStyle.GeneralsFight],
        style: ImgStyle.GeneralsFight,
        selected: false
    },
    {
        url: colorfulCartoonImgUrl,
        largeImgUrl: largeColorfulCartoonImgUrl,
        styleName: imgStyleMap[ImgStyle.ColorfulCartoon],
        style: ImgStyle.ColorfulCartoon,
        selected: false
    },
    {
        url: refinedStateStyleImgUrl,
        largeImgUrl: largeRefinedStateStyleImgUrl,
        styleName: imgStyleMap[ImgStyle.RefinedStateStyle],
        style: ImgStyle.RefinedStateStyle,
        selected: false
    },
    {
        url: newYearStyleImgUrl,
        largeImgUrl: largeNewYearStyleImgUrl,
        styleName: imgStyleMap[ImgStyle.NewYearStyle],
        style: ImgStyle.NewYearStyle,
        selected: false
    },
    {
        url: retroComicsImgUrl,
        largeImgUrl: largeRetroComicsImgUrl,
        styleName: imgStyleMap[ImgStyle.RetroComics],
        style: ImgStyle.RetroComics,
        selected: false
    },
    {
        url: fairyTaleImgUrl,
        largeImgUrl: largeFairyTaleImgUrl,
        styleName: imgStyleMap[ImgStyle["3DFairyTales"]],
        style: ImgStyle["3DFairyTales"],
        selected: false
    },
    {
        url: cartoonsImgUrl,
        largeImgUrl: largeCartoonsImgUrl,
        styleName: imgStyleMap[ImgStyle.Cartoons],
        style: ImgStyle.Cartoons,
        selected: false
    },
    {
        url: fresherImgUrl,
        largeImgUrl: largeFresherImgUrl,
        styleName: imgStyleMap[ImgStyle.Fresher],
        style: ImgStyle.Fresher,
        selected: false
    },
    {
        url: futureStyleImgUrl,
        largeImgUrl: largeFutureStyleImgUrl,
        styleName: imgStyleMap[ImgStyle.FutureStyle],
        style: ImgStyle.FutureStyle,
        selected: false
    }
];